export default "__VITE_ASSET__DPFLwNHY__"